// Pure helpers for the IDI-tab "Download Transcripts" action, extracted from
// idi_stakeholders.component.js so the download guard and the combined-report builder are
// unit-testable in the karma harness. Plain globals, matching services/idi_generate_payment.js.

// Returns a reason the transcript download must be blocked, or null when it may proceed.
// A stakeholder may download when it has recordings or a no-recording transcript.
globalThis.idiTranscriptDownloadBlockedReason = function (stakeholder) {
  const recordings = stakeholder?.recordings || [];
  const hasStakeholderTranscript = !!stakeholder?.transcript?.trim();
  if (recordings.length === 0 && !hasStakeholderTranscript) {
    return 'No transcripts found for this stakeholder';
  }
  return null;
};

// Builds the plain-text combined transcript report for an IDI stakeholder.
globalThis.buildIdiCombinedTranscript = function (idiProject, stakeholder, recordings) {
  const now = new Date();
  const entityLines = [
    `Stakeholder: ${stakeholder.stakeholder_name}`,
    `Email: ${stakeholder.stakeholder_email || 'N/A'}`,
    `Country: ${stakeholder.stakeholder_country?.name ?? 'N/A'}`,
    `IDI Project: ${idiProject.name || 'N/A'} (${idiProject.idi_id})`,
    `Generated: ${now.toLocaleDateString()} at ${now.toLocaleTimeString()}`
  ];
  return buildTranscriptReport(
    entityLines, 'STAKEHOLDER TRANSCRIPT (No Recordings)', stakeholder.transcript, recordings
  );
};
